import { StyledContainer, StyledLink, StyledTitle } from './styles/ProfileHeader.style'

import { ProfileHeaderProps } from './interfaces'
import { CLUBBI_PROFILE_EDIT_LINK } from '../../../common/constants'

export const ProfileHeader = ({ title }: ProfileHeaderProps) => {
  return (
    <StyledContainer>
      <StyledTitle>{title}</StyledTitle>
      <StyledLink href={CLUBBI_PROFILE_EDIT_LINK} target={'_blank'} rel="noreferrer">
        Como alterar meus dados?
      </StyledLink>
    </StyledContainer>
  )
}
